import 'whatwg-fetch'
import Vue from 'vue'

import ElementUI from 'element-ui'
import './../element-variables.scss'
import '../theme/index.css'
import { Popup, Picker, Toast, InfiniteScroll } from 'mint-ui'
import App from './App.vue'
import router from './router'
import store from './store'
import { registLoginTimeoutErrorHandler, registRequestErrorHandler } from './service/errorHandler'
import 'mint-ui/lib/style.css'
import Notice from './components/notice.vue'
import {windowMatchMobile} from "./util";
import {SERVICE_NUMBER} from './util/common'
import VConsole from 'vconsole';
import './css/mobile.less'
// import 'vant/lib/index.css';
// import { PasswordInput, NumberKeyboard, Form, Field,Uploader    } from 'vant';

import { numFormat } from '@gyasset/shared/utils'
import { webTracing } from '@gyasset/shared/utils';

if (['dev', 'test'].includes(process.env.VUE_APP_SERVER_ENV)) {
  const vConsole = new VConsole();
}
// MintUI
// Vue.use(MintUI)
Vue.use(InfiniteScroll)

Vue.component(Popup.name, Popup)
Vue.component(Picker.name, Picker)
Vue.component(Toast.name, Toast)
Vue.component('notice', Notice)
// Element //
Vue.use(ElementUI)
// Vue.use(Uploader)

// 全局挂载 Element UI 的 message 方法
Vue.prototype.$message = ElementUI.Message;
Vue.prototype.$webTracing = webTracing;
Vue.prototype.$tracingTrace = (data) => {
  webTracing.traceCustomEvent(data.eventId, data.title, {
    ...(data.params || {}),
    // 是否是移动端点击
    isMobile: windowMatchMobile(),
  })
};

Vue.config.productionTip = false

// 热更新
if (module.hot) {
  module.hot.accept();
}

export const EventBus = new Vue();

registRequestErrorHandler()
Vue.mixin({
  methods:{
    callTel(){ window.location.href = 'tel:' + SERVICE_NUMBER },
    callTelByNum(tel) { window.location.href = 'tel:' + tel },
    $notice(content) {
      this.$root.globalNotice.show = true
      this.$root.globalNotice.content = content
    },
    isLocalStorageSupported() {
      var testKey = 'test'
      var storage = window.sessionStorage
      try {
        storage.setItem(testKey, 'testValue')
        storage.removeItem(testKey)
        console.log('支持本地存储')
        return true
      } catch (error) {
        console.log('不支持本地存储')
        return false
      }
    },
    closeWeixinBrower(){
      if (typeof WeixinJSBridge === "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(), false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady());
          document.attachEvent('onWeixinJSBridgeReady',this.onBridgeReady());
        }
      } else {
        this.onBridgeReady();
      }
    },
    isWeiXinBrower(){
      var ua = window.navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == 'micromessenger'
    },
    onBridgeReady() {
      WeixinJSBridge.call("closeWindow");
    },
    resetWindow() {
      if (isAndroid) {
        return
      }
      let that = this
      this.$nextTick(function () {
        let body = document.body
        clearTimeout(body.timer)
        body.timer = setTimeout(function () {
          window.innerHeight = that.screenHeight
          window.outerHeight = that.screenHeight
          window.scroll(0, 0)
        }, 150)
      })
    },
    //四舍五入 保留place位小数，并添加千分位
    roundPlaceAddComma(num, place){
      const { keepPlaceAndAddComma } = numFormat
      return keepPlaceAndAddComma(num, place, { mathType: 'round' })
    },
    roundPlace(num, place){
      const { keepPlace } = numFormat
      return keepPlace(num, place, { mathType: 'round' })
    },
  }
})

Vue.directive('watermark',(el,binding)=>{
  function addWaterMarker(str,parentNode){// 水印文字，父元素，字体，文字颜色
    var can = document.createElement('canvas');
    parentNode.appendChild(can);
    can.width = 1500;
    can.height = 800;
    can.style.display = 'none';
    var cans = can.getContext('2d');
    cans.rotate(-20 * Math.PI / 180);
    cans.font = '24px SimSun';
    cans.fillStyle = 'rgb(201, 201, 201)';
    cans.textAlign = 'left';
    cans.textBaseline = 'Middle';
    cans.fillText(str, can.width / 2.2, can.height / 1.8);
    cans.fillText(str, can.width / 3, can.height / 2.6);
    cans.fillText(str, can.width / 8 , can.height / 1.8);
    cans.fillText(str, can.width / 512, can.height / 2.6);
    parentNode.style.backgroundImage = "url(" + can.toDataURL("image/png") + ")";
  }
  addWaterMarker(binding.value.text, el, binding.value.font, binding.value.textColor)
})


Vue.directive('track-click',{
  inserted(el, binding) {
    el.addEventListener('click', function () {
      const {eventId, title, params} = binding.value

      // 执行埋点逻辑
      // webTracing.traceCustomEvent(eventId, title, {
      //   ...(params || {}),
      //   // 是否是移动端点击
      //   isMobile: windowMatchMobile(),
      // },);
    });
  }
});

// isMobile: 是否手机用户, globalNotice：全局提醒框, 鸿蒙系统 ArkWeb|deviceType
const isMobile = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|ArkWeb|deviceType)/i.test(navigator.userAgent)
const isAndroid = /Android/i.test(navigator.userAgent)

const globalNotice = {
  show: false,
  content: ''
}

Vue.config.ignoredElements = [
  'wx-open-launch-weapp',
]

new Vue({
  router,
  store,
  data: { isMobile,isAndroid, parentPath: '', parentTitle: '', globalNotice, goBackFunc: null},
  render: h => h(App)
}).$mount('#app')

registLoginTimeoutErrorHandler({ store, router })
